module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("er3RP"))).then(() => parcelRequire('5erN3'));